import { createUseStyles } from "react-jss";

export const RequestDetailProgressBarStyle = createUseStyles((theme: any) => ({
    progressRequest: {
        display: "flex",
        flexDirection: "column",
        gap: 10,
    },
    progresRequestData: {
        display: "flex",
        justifyContent: "space-between",
    },
    progresRequestDataSection: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-around",
        color: "var(--text-color-purple)",
        padding: 5,
        gap: 5,
    },
    label: {
        padding: 5,
    },
}));
